import { Component, OnInit } from '@angular/core';
import { MatDialog } from "@angular/material";
import { MatDialogRef } from "@angular/material";
import { SharedService } from "./../../shared/shared.service";
import { DevoteeService } from './../devotee.service';
import { ActionStatus } from './../../shared/action-status';
import { ActionStatusService } from "./../../shared/action-status.service";

@Component({
  selector: 'app-devotee-message-for-admin',
  templateUrl: './devotee-message-for-admin.component.html',
  styleUrls: ['./devotee-message-for-admin.component.css']
})
export class DevoteeMessageForAdminComponent implements OnInit {

  constructor
    (private dialogRef: MatDialogRef<DevoteeMessageForAdminComponent>,
    private sharedService: SharedService,
    private actionStatusService: ActionStatusService,
  ) { }

  messageForAdmin: string = "";
  savedMessage: string = "";
  errorMessage: string = "";

  ngOnInit() {

  }

  closePopup(): void {
    this.dialogRef.close();
  }

  sendMsg(): void {

    if (this.messageForAdmin == "") {
      this.errorMessage = "Please enter message";
      return;
    }

    let devoteeDetail=this.sharedService.getDevoteeDataAtLocStorage();
    

    let actionStatus = new ActionStatus();
    actionStatus.MobileNo = devoteeDetail.MobileNo;
    actionStatus.Comment = this.messageForAdmin;
    actionStatus.ActionId = 4;
    actionStatus.Status = 1;

    this.sharedService.showSpinner();
    this.actionStatusService.save(actionStatus).subscribe(
      data => this.savedMessage = data,
      err => this.errorMessage = err.error.Message,
      () => {
        this.sharedService.hideSpinner();
        this.dialogRef.close("Admin will contact and update details mentioned soon");        
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/devotee/devotee-message-for-admin/devotee-message-for-admin.component.ts